import {
  createUser,
  forgotPassword,
  getUser,
  issueUnifiedLoginTicket,
  redeemUnifiedLoginTicket,
} from "@ckweb/ckfetch/connectables/plantApi";

export function useCreateUser() {
  return useSafeLocalFetch("createUser", createUser, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useForgotPassword() {
  return useSafeLocalFetch("forgotPassword", forgotPassword, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    mapError: "auth.forgotUsernameOrPasswordErrorMessage",
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}

export function useGetUser() {
  return useSafeLocalFetch("getUser", getUser, {
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
}

export function useIssueAuthTicket() {
  return useSafeLocalFetch("issueUnifiedLoginTicket", issueUnifiedLoginTicket, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
  });
}

export function useRedeemAuthTicket() {
  return useSafeLocalFetch("redeemUnifiedLoginTicket", redeemUnifiedLoginTicket, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
  });
}
